import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import HeroSection from "../components/HeroSection";
import About from "../components/About";
import Process from "../components/Process";
import Register from "../components/Register";
import Footer from "../components/Footer";

const Index = () => {
  const location = useLocation();

  // Handle scroll to section when navigating from another page
  useEffect(() => {
    if (location.state?.scrollTo) {
      // Small delay to ensure page is rendered
      setTimeout(() => {
        const element = document.getElementById(location.state.scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);

      // Clear the state to prevent scrolling on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <Box sx={{ px: -1, mx: -1, my: -1, overflow: "hidden" }}>
      <HeroSection />
      <About />
      <Process />
      <Register />
      <Footer />
    </Box>
  );
};

export default Index;
